import { Toaster } from "sonner";

export default function ToastContainer() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        classNames: {
          success:
            "bg-green-50 border border-green-200 text-green-800 shadow-lg",
          error: "bg-red-50 border border-red-200 text-red-800 shadow-lg",
          info: "bg-blue-50 border border-blue-200 text-blue-800 shadow-lg",
          warning:
            "bg-yellow-50 border border-yellow-200 text-yellow-800 shadow-lg",
        },
      }}
      closeButton
      richColors={false}
    />
  );
}
